import { Box, Button, Grid, Typography } from '@mui/material';
import { SuccessIllustration } from '../../assets/illustration';
import { fonts } from '../../theme/typography';
import { AppIcon } from '../app-icon/AppIcon';

interface ModalSuccessProps {
  primaryBtnLabel?: string;
  handlePrimaryBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  secondaryBtnLabel?: string;
  handleSecondaryBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  successMessage: string;
}
export const ModalSuccess: React.FC<ModalSuccessProps> = ({
  primaryBtnLabel,
  handlePrimaryBtnClick,
  secondaryBtnLabel,
  handleSecondaryBtnClick,
  successMessage,
}) => {
  return (
    <Box>
      <Box sx={{ maxWidth: '25rem', m: 'auto', textAlign: 'center' }}>
        <Box sx={{ mb: 7.5 }}>
          <AppIcon sx={{ height: '10rem', width: 'auto' }} Icon={SuccessIllustration} role="presentation" />
        </Box>
        <Typography
          color="success"
          component="h6"
          fontFamily={fonts.heading}
          fontWeight="Bold"
          variant="large"
          sx={{ mb: 3 }}
        >
          Congratulation
          <br />
          {successMessage}
        </Typography>
        {((primaryBtnLabel && handlePrimaryBtnClick) || (secondaryBtnLabel && handleSecondaryBtnClick)) && (
          <Grid justifyContent="center" container spacing={1.5}>
            {secondaryBtnLabel && handleSecondaryBtnClick && (
              <Grid item>
                <Button onClick={handleSecondaryBtnClick} variant="default">
                  {secondaryBtnLabel}
                </Button>
              </Grid>
            )}
            {primaryBtnLabel && handlePrimaryBtnClick && (
              <Grid item>
                <Button onClick={handlePrimaryBtnClick} variant="contained">
                  {primaryBtnLabel}
                </Button>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </Box>
  );
};
